module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_05_1280_1280_en-59e16226de4787864ebfc61d110be314.jpg";